<template lang="html">
  <div class="container">

    <div class="header">
      <!-- <div class="top">
        <p class="yes">业务</p>
        <p>制作</p>
        <p>阿米巴</p>
      </div> -->

      <p class="select">
        {{year}}年度
        <!-- <img src="../assets/img/avatar.jpg" alt=""  @click="filter"> -->
        <i class="icon iconfont icon-shaixuan" @click="filter"></i>
      </p>
      <div class="list">

        <p class="table1 borb ">
          <span class="col">
            <span class="small">¥</span>
            {{ yearData.hasTotalMoney == undefined ? '' : (yearData.hasTotalMoney/10000).toFixed(2) }}
            <span class="small">(万)</span>
          </span>
          <span class="col1">已签约项目</span>
        </p>

        <p class="table1 borb borl">
          <span class="col">{{yearData.backMoneyRate}}</span>
          <span class="col1">回款比例</span>
        </p>

        <div class="table1">
         <span class="col">
            <span class="small">¥</span>
            {{ yearData.hasBackMoney == undefined ? '' : (yearData.hasBackMoney/10000).toFixed(2) }}
            <span class="small">(万)</span>
          </span>
          <span class="col1">已回款</span>
        </div>

        <div class="table1 borl">
          <p class="col">
            {{yearData.hasCount}}
          </p>
          <span class="col1">已签约项目数</span>
        </div>


      </div>
    </div>


    <div class="data">
      <ul>
        <li>
          <span class="left">已制作完成待回款</span>
          <span class="right">¥{{ yearData.hasOkWaitMoney == undefined ? '' : (yearData.hasOkWaitMoney/10000).toFixed(2)}}(万元)</span>
        </li>


        <li>
          <span class="left">已签约待回款</span>
          <span class="right">¥{{ yearData.hasContractWaitMoney == undefined ? '' : (yearData.hasContractWaitMoney/10000).toFixed(2)}}(万元)</span>
        </li>


        <li>
          <span class="left">已开票待回款</span>
          <span class="right">¥{{ yearData.hasInvoiceWaitMoney == undefined ? '' : (yearData.hasInvoiceWaitMoney/10000).toFixed(2)}}(万元)</span>
        </li>
      </ul>




      <p class="btn" @click="toMore">更多数据</p>
    </div>


    <div class="rank">

      <p class="test">
        销售／回款月度总金额
      </p>
      <IEcharts :option="line1"></IEcharts>

    </div>

    <div class="percent1">
      <p class="test">
        区域销售总金额
      </p>
      <IEcharts :option="line2"></IEcharts>
    </div>

    <div class="percent2">
      <p class="test">
        区域回款总金额
      </p>
      <IEcharts :option="line3"></IEcharts>
    </div>


    <div class="zhezhao" v-if="isFilter" @click="cancel"></div>

    <!--筛选-->
      <div class="selbox"  v-if="isFilter">
        <p>筛选</p>

        <p class="content">
          时间
        </p>

        <ul class="listtime">
          <li :class="{'true':filterType == 1}" @click="filterType = 1">本月</li>
          <li :class="{'true':filterType == 2}" @click="filterType = 2">年度</li>
        </ul>

        <p class="btnyes" @click="confirmFilter">确定</p>
      </div>

  </div>
</template>

<script>
import config from '../fetch/config'
import IEcharts from 'vue-echarts-v3/src/lite.js'
import 'echarts/lib/component/legend'
// import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/markPoint'
// import 'echarts/lib/component/markLine'

export default {
  components: {
    IEcharts
  },
  data () {
    return {
      // tabType:1,
      year:null,
      isFilter:false,
      filterType:2,
      yearData:[],
      line1:{
        tooltip : {
          trigger: 'axis',
        },
        grid: {
          left: '6%',
          right: '12%',
          top:'26%',
          bottom: '12%',
          containLabel: true
        },
        legend: {
          icon: 'rect', //设置图例的图形形状，circle为圆，rect为矩形
          itemWidth: 25, //图例标记的图形宽度[ default: 25 ]
          itemHeight: 2, //图例标记的图形高度。[ default: 14 ]
          itemGap: 50, //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。[ default: 10 ]
          data: ['回款金额', '销售金额'],
          bottom:'3%',
          // right: '26%', //图例组件离容器右侧的距离
          textStyle: {
              fontSize: 12,
              color: '#475669'
          }
        },
        xAxis: [{
          type: 'category',
          name:'(月)',
          axisTick: {
              // alignWithLabel: true
              show:false,
          },
          axisLabel:{
            textStyle:{
              color:'#475669'
            }
          },
          nameTextStyle:{
            color:'#475669',
            align:'center',
            fontSize:12,
          },
          axisLine:{
            lineStyle:{
              color:'#E4E4E4',
            }
          },
          data: ['1','2','3','4','5','6','7','8','9','10','11','12'],
        }],
        yAxis: [{
         type: 'value',
         name: '',
         min: 0,
         axisTick:{
           show:false,
         },
         axisLine:{
           show:false,
          //  lineStyle:{
          //    color:'#E4E4E4',
          //  }
         },
        //  splitLine: {
        //     show: false
        //  },
         nameTextStyle:{
           color:'#333',
           align:'center',
           fontSize:12,
         },
         axisLabel:{
           textStyle:{
             color:'#475669'
           }
         },
        }],
       series: [{
          name: '销售金额',
          color:['#9A89F1'],
          type: 'line',
          label: {
              normal: {
                  show: false,
                  position: 'top',
              }
          },
          markPoint: {
              data: [{
                  type: 'max',
                  name: '最大值'
              }],
              symbol:'pin',
              symbolSize:'30',
              label:{
                normal:{
                  show:true,
                  fontSize:8,
                  formatter:function (data) {
                    return data.value.toFixed(1)
                  }
                }
              },
          },
          lineStyle: {
              normal: {
                  width: 2,
              }
          },
          areaStyle:{
              normal:{
                  color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                          offset: 0, color: '#9A89F1' // 0% 处的颜色
                      },  {
                          offset: 0.5, color: 'rgba(154,137,241,0.1)' // 100% 处的颜色
                      }],
                      globalCoord: false // 缺省为 false
                  }
              }
          },
          data: []
        }, {
            name: '回款金额',
            color:['#76B2F9'],
            type: 'line',
            label: {
                normal: {
                    show: false,
                    position: 'top',
                }
            },
            lineStyle: {
                normal: {
                    width: 2,
                }
            },
            markPoint: {
                data: [{
                    type: 'max',
                    name: '最大值'
                }],
                symbol:'pin',
                symbolSize:'30',
                label:{
                  normal:{
                    show:true,
                    fontSize:8,
                    formatter:function (data) {
                      return data.value.toFixed(1)
                    }
                  }
                },
            },
            areaStyle:{
                normal:{
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#76B2F9' // 0% 处的颜色
                        },  {
                            offset: 0.5, color: 'rgba(118,178,249,.1)' // 100% 处的颜色
                        }],
                        globalCoord: false // 缺省为 false
                    }
                }
            },
            data: []
        }]
      },
      line2:{
        grid: {
          left: '6%',
          right: '12%',
          top:'22%',
          bottom: '16%',
          containLabel: true
        },
        tooltip : {
          trigger: 'axis',
        },
        legend: {
          icon: 'rect', //设置图例的图形形状，circle为圆，rect为矩形
          width:200,
          itemWidth: 25, //图例标记的图形宽度[ default: 25 ]
          itemHeight: 2, //图例标记的图形高度。[ default: 14 ]
          itemGap: 10, //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。[ default: 10 ]
          data: ['北京', '上海','深圳','珠海','海南','成都','渠道'],
          bottom:'3%',
          right: '26%', //图例组件离容器右侧的距离
          textStyle: {
              fontSize: 12,
              color: '#475669'
          }
        },
        xAxis: [{
          type: 'category',
          name:'(月)',
          axisTick: {
              // alignWithLabel: true
              show:false,
          },
          axisLabel:{
            textStyle:{
              color:'#475669'
            }
          },
          nameTextStyle:{
            color:'#475669',
            align:'center',
            fontSize:12,
          },
          axisLine:{
            lineStyle:{
              color:'#E4E4E4',
            }
          },
          data: ['1','2','3','4','5','6','7','8','9','10','11','12'],
        }],
        yAxis: [{
         type: 'value',
         name: '',
         min: 0,
         axisTick:{
           show:false,
         },
         axisLine:{
           show:false,
          //  lineStyle:{
          //    color:'#E4E4E4',
          //  }
         },
         nameTextStyle:{
           color:'#333',
           align:'center',
           fontSize:12,
         },
         axisLabel:{
           textStyle:{
             color:'#475669'
           }
         },
        }],
        series: [{
          name: '上海',
          color:['#EC7A8A'],
          type: 'line',
          label: {
              normal: {
                  show: false,
                  position: 'top',
              }
          },
          markPoint: {
              data: [{
                  type: 'max',
                  name: '最大值'
              }],
              symbol:'pin',
              symbolSize:'30',
              label:{
                normal:{
                  show:true,
                  fontSize:8,
                  formatter:function (data) {
                    return data.value.toFixed(1)
                  }
                }
              },
          },
          lineStyle: {
              normal: {
                  width: 1,
              }
          },
          areaStyle:{
              normal:{
                  color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                          offset: 0, color: '#EC7A8A' // 0% 处的颜色
                      },  {
                          offset: 0.5, color: 'rgba(236,122,138,.1)' // 100% 处的颜色
                      },
                      {
                          offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                      }],
                      globalCoord: false // 缺省为 false
                  }
              }
          },
          data: []
        }, {
            name: '北京',
            color:['#76B2F9'],
            type: 'line',
            label: {
                normal: {
                    show: false,
                    position: 'top',
                }
            },
            lineStyle: {
                normal: {
                    width: 1,
                }
            },
            markPoint: {
                data: [{
                    type: 'max',
                    name: '最大值'
                }],
                symbol:'pin',
                symbolSize:'30',
                label:{
                  normal:{
                    show:true,
                    fontSize:8,
                    formatter:function (data) {
                      return data.value.toFixed(1)
                    }
                  }
                },
            },
            areaStyle:{
                normal:{
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#76B2F9' // 0% 处的颜色
                        },  {
                            offset: 0.5, color: 'rgba(118,178,249,.1)' // 100% 处的颜色
                        },
                        {
                            offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                        }],
                        globalCoord: false // 缺省为 false
                    }
                }
            },
            data: []
        },
        {
           name: '深圳',
           color:['#FAE35A'],
           type: 'line',
           label: {
               normal: {
                   show: false,
                   position: 'top',
               }
           },
           markPoint: {
               data: [{
                   type: 'max',
                   name: '最大值'
               }],
               symbol:'pin',
               symbolSize:'30',
               label:{
                 normal:{
                   show:true,
                   fontSize:8,
                   formatter:function (data) {
                     return data.value.toFixed(1)
                   }
                 }
               },
           },
           lineStyle: {
               normal: {
                   width: 1,
               }
           },
           areaStyle:{
               normal:{
                   color: {
                       type: 'linear',
                       x: 0,
                       y: 0,
                       x2: 0,
                       y2: 1,
                       colorStops: [{
                           offset: 0, color: '#FAE35A' // 0% 处的颜色
                       },  {
                           offset: 0.5, color: 'rgba(250,227,90,.1)' // 100% 处的颜色
                       },
                       {
                           offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                       }],
                       globalCoord: false // 缺省为 false
                   }
               }
           },
           data: []
         },
        //  {
        //     name: '珠海',
        //     color:['#9A89F1'],
        //     type: 'line',
        //     label: {
        //         normal: {
        //             show: false,
        //             position: 'top',
        //         }
        //     },
        //     markPoint: {
        //         data: [{
        //             type: 'max',
        //             name: '最大值'
        //         }],
        //         symbol:'pin',
        //         symbolSize:'40',
        //     },
        //     lineStyle: {
        //         normal: {
        //             width: 1,
        //         }
        //     },
        //     areaStyle:{
        //         normal:{
        //             color: {
        //                 type: 'linear',
        //                 x: 0,
        //                 y: 0,
        //                 x2: 0,
        //                 y2: 1,
        //                 colorStops: [{
        //                     offset: 0, color: '#9A89F1' // 0% 处的颜色
        //                 },  {
        //                     offset: 0.5, color: 'rgba(154,137,241,.1)' // 100% 处的颜色
        //                 },
        //                 {
        //                     offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
        //                 }],
        //                 globalCoord: false // 缺省为 false
        //             }
        //         }
        //     },
        //     data: [11,2,5,6,12,13,2,3,6,1,22,12]
        //   },
          {
             name: '海南',
             color:['#FFA761'],
             type: 'line',
             label: {
                 normal: {
                     show: false,
                     position: 'top',
                 }
             },
             markPoint: {
                 data: [{
                     type: 'max',
                     name: '最大值'
                 }],
                 symbol:'pin',
                 symbolSize:'30',
                 label:{
                   normal:{
                     show:true,
                     fontSize:8,
                     formatter:function (data) {
                       return data.value.toFixed(1)
                     }
                   }
                 },
             },
             lineStyle: {
                 normal: {
                     width: 1,
                 }
             },
             areaStyle:{
                 normal:{
                     color: {
                         type: 'linear',
                         x: 0,
                         y: 0,
                         x2: 0,
                         y2: 1,
                         colorStops: [{
                             offset: 0, color: '#FFA761' // 0% 处的颜色
                         },  {
                             offset: 0.5, color: 'rgba(255,167,97,.1)' // 100% 处的颜色
                         },{
                             offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                         }],
                         globalCoord: false // 缺省为 false
                     }
                 }
             },
             data: []
           },{
              name: '成都',
              color:['#86E687'],
              type: 'line',
              label: {
                  normal: {
                      show: false,
                      position: 'top',
                  }
              },
              markPoint: {
                  data: [{
                      type: 'max',
                      name: '最大值'
                  }],
                  symbol:'pin',
                  symbolSize:'30',
                  label:{
                    normal:{
                      show:true,
                      fontSize:8,
                      formatter:function (data) {
                        return data.value.toFixed(1)
                      }
                    }
                  },
              },
              lineStyle: {
                  normal: {
                      width: 1,
                  }
              },
              areaStyle:{
                  normal:{
                      color: {
                          type: 'linear',
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [{
                              offset: 0, color: '#86E687' // 0% 处的颜色
                          },  {
                              offset: 0.5, color: 'rgba(134,230,135,.1)' // 100% 处的颜色
                          },{
                              offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                          }],
                          globalCoord: false // 缺省为 false
                      }
                  }
              },
              data: []
            }]
      },
      line3:{
        grid: {
          left: '6%',
          right: '12%',
          top:'22%',
          bottom: '16%',
          containLabel: true
        },
        tooltip : {
          trigger: 'axis',
        },
        legend: {
          icon: 'rect', //设置图例的图形形状，circle为圆，rect为矩形
          width:200,
          itemWidth: 25, //图例标记的图形宽度[ default: 25 ]
          itemHeight: 2, //图例标记的图形高度。[ default: 14 ]
          itemGap: 10, //图例每项之间的间隔。横向布局时为水平间隔，纵向布局时为纵向间隔。[ default: 10 ]
          data: ['北京', '上海','深圳','海南','成都','渠道'],
          bottom:'3%',
          right: '26%', //图例组件离容器右侧的距离
          textStyle: {
              fontSize: 12,
              color: '#475669'
          }
        },
        xAxis: [{
          type: 'category',
          name:'(月)',
          axisTick: {
              // alignWithLabel: true
              show:false,
          },
          axisLabel:{
            textStyle:{
              color:'#475669'
            }
          },
          nameTextStyle:{
            color:'#475669',
            align:'center',
            fontSize:12,
          },
          axisLine:{
            lineStyle:{
              color:'#E4E4E4',
            }
          },
          data: ['1','2','3','4','5','6','7','8','9','10','11','12'],
        }],
        yAxis: [{
         type: 'value',
         name: '',
         min: 0,
         axisTick:{
           show:false,
         },
         axisLine:{
           show:false,
          //  lineStyle:{
          //    color:'#E4E4E4',
          //  }
         },
         nameTextStyle:{
           color:'#333',
           align:'center',
           fontSize:12,
         },
         axisLabel:{
           textStyle:{
             color:'#475669'
           }
         },
        }],
        series: [{
          name: '上海',
          color:['#EC7A8A'],
          type: 'line',
          label: {
              normal: {
                  show: false,
                  position: 'top',
              }
          },
          markPoint: {
              data: [{
                  type: 'max',
                  name: '最大值'
              }],
              symbol:'pin',
              symbolSize:'30',
              label:{
                normal:{
                  show:true,
                  fontSize:8,
                  formatter:function (data) {
                    return data.value.toFixed(1)
                  }
                }
              },
          },
          lineStyle: {
              normal: {
                  width: 1,
              }
          },
          areaStyle:{
              normal:{
                  color: {
                      type: 'linear',
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [{
                          offset: 0, color: '#EC7A8A' // 0% 处的颜色
                      },  {
                          offset: 0.5, color: 'rgba(236,122,138,.1)' // 100% 处的颜色
                      },{
                          offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                      }],
                      globalCoord: false // 缺省为 false
                  }
              }
          },
          data: []
        }, {
            name: '北京',
            color:['#76B2F9'],
            type: 'line',
            label: {
                normal: {
                    show: false,
                    position: 'top',
                }
            },
            lineStyle: {
                normal: {
                    width: 1,
                }
            },
            markPoint: {
                data: [{
                    type: 'max',
                    name: '最大值'
                }],
                symbol:'pin',
                symbolSize:'30',
                label:{
                  normal:{
                    show:true,
                    fontSize:8,
                    formatter:function (data) {
                      return data.value.toFixed(1)
                    }
                  }
                },
            },
            areaStyle:{
                normal:{
                    color: {
                        type: 'linear',
                        x: 0,
                        y: 0,
                        x2: 0,
                        y2: 1,
                        colorStops: [{
                            offset: 0, color: '#76B2F9' // 0% 处的颜色
                        },  {
                            offset: 0.5, color: 'rgba(118,178,249,.1)' // 100% 处的颜色
                        },
                        {
                            offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                        }],
                        globalCoord: false // 缺省为 false
                    }
                }
            },
            data: []
        },
        {
           name: '深圳',
           color:['#FAE35A'],
           type: 'line',
           label: {
               normal: {
                   show: false,
                   position: 'top',
               }
           },
           markPoint: {
               data: [{
                   type: 'max',
                   name: '最大值'
               }],
               symbol:'pin',
               symbolSize:'30',
               label:{
                 normal:{
                   show:true,
                   fontSize:8,
                   formatter:function (data) {
                     return data.value.toFixed(1)
                   }
                 }
               },
           },
           lineStyle: {
               normal: {
                   width: 1,
               }
           },
           areaStyle:{
               normal:{
                   color: {
                       type: 'linear',
                       x: 0,
                       y: 0,
                       x2: 0,
                       y2: 1,
                       colorStops: [{
                           offset: 0, color: '#FAE35A' // 0% 处的颜色
                       },  {
                           offset: 0.5, color: 'rgba(250,227,90,.1)' // 100% 处的颜色
                       },
                       {
                           offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                       }],
                       globalCoord: false // 缺省为 false
                   }
               }
           },
           data: []
         },
        //  {
        //     name: '珠海',
        //     color:['#9A89F1'],
        //     type: 'line',
        //     label: {
        //         normal: {
        //             show: false,
        //             position: 'top',
        //         }
        //     },
        //     markPoint: {
        //         data: [{
        //             type: 'max',
        //             name: '最大值'
        //         }],
        //         symbol:'pin',
        //         symbolSize:'40',
        //     },
        //     lineStyle: {
        //         normal: {
        //             width: 1,
        //         }
        //     },
        //     areaStyle:{
        //         normal:{
        //             color: {
        //                 type: 'linear',
        //                 x: 0,
        //                 y: 0,
        //                 x2: 0,
        //                 y2: 1,
        //                 colorStops: [{
        //                     offset: 0, color: '#D185FF' // 0% 处的颜色
        //                 },  {
        //                     offset: 0.5, color: 'rgba(154,137,241,.1)' // 100% 处的颜色
        //                 },
        //                 {
        //                     offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
        //                 }],
        //                 globalCoord: false // 缺省为 false
        //             }
        //         }
        //     },
        //     data: [11,2,5,6,12,13,2,3,6,1,22,12]
        //   },
          {
             name: '海南',
             color:['#FFA761'],
             type: 'line',
             label: {
                 normal: {
                     show: false,
                     position: 'top',
                 }
             },
             markPoint: {
                 data: [{
                     type: 'max',
                     name: '最大值'
                 }],
                 symbol:'pin',
                 symbolSize:'30',
                 label:{
                   normal:{
                     show:true,
                     fontSize:8,
                     formatter:function (data) {
                       return data.value.toFixed(1)
                     }
                   }
                 },
             },
             lineStyle: {
                 normal: {
                     width: 1,
                 }
             },
             areaStyle:{
                 normal:{
                     color: {
                         type: 'linear',
                         x: 0,
                         y: 0,
                         x2: 0,
                         y2: 1,
                         colorStops: [{
                             offset: 0, color: '#FFA761' // 0% 处的颜色
                         },  {
                             offset: 0.5, color: 'rgba(255,167,97,.1)' // 100% 处的颜色
                         },
                         {
                             offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                         }],
                         globalCoord: false // 缺省为 false
                     }
                 }
             },
             data: []
           },{
              name: '成都',
              color:['#86E687'],
              type: 'line',
              label: {
                  normal: {
                      show: false,
                      position: 'top',
                  }
              },
              markPoint: {
                  data: [{
                      type: 'max',
                      name: '最大值'
                  }],
                  symbol:'pin',
                  symbolSize:'30',
                  label:{
                    normal:{
                      show:true,
                      fontSize:8,
                      formatter:function (data) {
                        return data.value.toFixed(1)
                      }
                    }
                  },
              },
              lineStyle: {
                  normal: {
                      width: 1,
                  }
              },
              areaStyle:{
                  normal:{
                      color: {
                          type: 'linear',
                          x: 0,
                          y: 0,
                          x2: 0,
                          y2: 1,
                          colorStops: [{
                              offset: 0, color: '#86E687' // 0% 处的颜色
                          },  {
                              offset: 0.5, color: 'rgba(134,230,135,.1)' // 100% 处的颜色
                          },
                          {
                              offset: 1, color: 'rgba(255,255,255,1)' // 100% 处的颜色
                          }],
                          globalCoord: false // 缺省为 false
                      }
                  }
              },
              data: []
            }]
      },
    }
  },
  methods:{
    filter () {
      this.isFilter = true
      this.$emit('inFilter')
    },
    confirmFilter () {
      if ( this.filterType == 2 ) {
        // this.isFilter = false
      } else {
        this.$router.push({ name:'businessmon'})
      }
      this.$emit('noFilter')
      this.isFilter = false
    },
    cancel () {
      this.isFilter = false
      this.$emit('noFilter')
    },
    toMore () {
      this.$router.push({ name:'analyze'})
    },
    changeTab (type) {
      this.tabType = type
    }
  },
  created () {
    this.$notice.loading()
    var d = new Date()
    this.year = d.getFullYear()
    this.$http.getBusiness().then( res => {
      this.yearData = res.data.yearData
      this.$notice.loading(false)
    })
    this.$http.getLineChart().then( res => {
      res.data.lineSaleBackMoney.map ( item => {
        if (item.name == "上海" ) {
          this.line2.series[0].data = item.data
        } else if (item.name == "北京" ) {
          this.line2.series[1].data = item.data
        } else if (item.name == "深圳" ) {
          this.line2.series[2].data = item.data
        } else if (item.name == '海南') {
          this.line2.series[3].data = item.data
        } else if (item.name == '成都') {
          this.line2.series[4].data = item.data
        }
      })
      res.data.lineSaleTotalMoney.map ( item => {
        if (item.name == "上海" ) {
          this.line3.series[0].data = item.data
        } else if (item.name == "北京" ) {
          this.line3.series[1].data = item.data
        } else if (item.name == "深圳" ) {
          this.line3.series[2].data = item.data
        } else if (item.name == '海南') {
          this.line3.series[3].data = item.data
        } else if (item.name == '成都') {
          this.line3.series[4].data = item.data
        }
      })
    })

    this.$http.getZhuChart().then ( res => {
      this.line1.series[0].data = res.data.zhuSaleTotalRate
      this.line1.series[1].data = res.data.zhuSaleBackRate
    })
  },

}
</script>

<style lang="css" scoped>
.container {
  width: 100%;
  background-color: #fafafa;
}
.container.filter{
  height: 100%;
  overflow: hidden;
}
.header{
  width: 100%;
  background: #f5f5f5;
  padding-top: 0.15625rem;
  margin-bottom: 0.21875rem;
}
.select{
  width: 100%;
  color: #fff;
  height: 1.1875rem;
  background: #5483D2;
  font-size: 0.4375rem;
  line-height: 1.1875rem;
  padding-left: 0.34375rem;
  margin-bottom: 0.1875rem;
  position: relative;
}
.header .icon{
  font-size: 0.5rem;
  position: absolute;
  right: 0.5rem;
  top: 0;
  margin: auto;
}
.yes{
  background: #5483D2;
  color: #fff;
}
.top{
  width: 85%;
  border: 1px solid #5483D2;
  color: #737171;
  font-size: 0;
  margin: auto;
  border-radius: 0.09375rem;
  margin-bottom: 0.25rem;
}
.top p{
  font-size: 0.4375rem;
  display: inline-block;
  width: 33.3%;
  text-align: center;
  border-right: 1px solid #5483D2;
  padding: 0.125rem;
}
.top p:last-child{
  border:0;
}
.list{
  width: 100%;
  margin: auto;
  color: #000;
  height: 5.46875rem;
  border: 0;
  background: #fff;
}
.data{
  width: 95%;
  margin: auto;
  color: #000;
  height: 6rem;
  border: 0;
  box-shadow: 0 0 5px #979797;
  border-radius: 0.25rem;
  background: #fff;
  margin-bottom: 0.25rem;
  padding-top: 0.75rem;
}
.data ul li {
  width: 88%;
  margin: auto;
  color: #333;
  font-size: 0.4375rem;
  margin-bottom: 0.75rem;
  font-family: PingFangSC-Regular;
  font-weight: 500;
}
.left{
  text-align: left;
  display: inline-block;
  width: 50%;
  float: left;
}
.right{
  text-align: right;
  display: inline-block;
  width: 50%;
}

.rank{
  color: #000;
  height: 8.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}
.percent1{
  color: #000;
  height: 8.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}
.percent2{
  color: #000;
  height: 8.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}
/*.percent3{
  color: #000;
  height: 11.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}
.percent4{
  color: #000;
  height: 11.6875rem;
  position: relative;
  width: 100%;
  background: #fff;
  margin-bottom: 0.375rem;
}*/
.test{
  border-left: 0.09375rem solid #5483D2;
  width: 96%;
  position: absolute;
  right: 0;
  top: 0.6875rem;
  font-size:0.375rem;
  color: #333333;
  font-family:PingFangSC-Regular;
  padding-left: 2%;
  font-weight: 500;
}
.test span{
  position: absolute;
  right: 5%;
  font-family:PingFangSC-Regular;
  color:rgba(153,153,153,1);
  font-size:0.75rem;
}
.table1{
  width: 50%;
  float: left;
  height: 2.65625rem;
  text-align: center;
  padding-top: 0.6875rem;
}
.borb{
  border-bottom: 1px solid #ddd;
}
.borl{
  border-left: 1px solid #ddd;
}

.col{
  font-size: 0.625rem;
  color: #333333;
  font-family:PingFangSC-Regular;
  display: block;
}
.col1{
  font-size: 0.375rem;
  color: #A4C7FF;
  font-family:PingFangSC-Regular;
}
.small{
  color: #333333;
  font-size: 0.375rem;
  display: inline-block;
}
.btn{
  border: 1px solid #5483D2;
  color: #5483D2;
  height: 0.75rem;
  line-height: 0.75rem;
  text-align: center;
  border-radius: 0.625rem;
  width: 5.4375rem;
  margin: auto;
  font-size: 0.4375rem;
}
.zhezhao{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .5);
  z-index: 9;
  width: 100%;
  height: 100%;
}
.selbox{
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 7.0625rem;
  z-index: 99;
  background: #fff;
}
.selbox p:first-child{
  color: #999999;
  background: #F2F2F2;
  font-size: 0.375rem;
  height: 0.9375rem;
  line-height: 0.9375rem;
  padding-left: 0.46875rem;
}
.content{
  background: #fff;
  color: #333333;
  font-size: 0.4375rem;
  padding-left: 0.34375rem;
  padding-top: 0.1875rem;

}
.listtime{
  margin-top: 0.8125rem;
}
.listtime li{
  width: 2.0625rem;
  text-align: center;
  height: 0.84375rem;
  line-height: 0.84375rem;
  border-radius: 0.125rem;
  background: #F1F1F1;
  color: #333333;
  display: inline-block;
  font-size: 0.375rem;
}
.listtime li:first-child{
  margin-left: 0.78125rem;
  margin-right: 0.46875rem;
}
.true{
  color: #5483D2!important;
  background: #C9DDFD!important;
}
.btnyes{
  height: 1.25rem;
  line-height: 1.25rem;
  background: #5483D2;
  position: absolute;
  width: 100%;
  bottom: 0;
  text-align: center;
  color: #fff;
  font-size: 0.4375rem;
}
</style>
e>



// WEBPACK FOOTER //
// src/components/BusinessYear.vue